import { render, staticRenderFns } from "./ModuleSubCard.vue?vue&type=template&id=7a3a5263&scoped=true&"
import script from "./ModuleSubCard.vue?vue&type=script&lang=js&"
export * from "./ModuleSubCard.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSubCard.vue?vue&type=style&index=0&id=7a3a5263&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a5263",
  null
  
)

export default component.exports